import React from "react";
import UserPhotosAndVideos from "../UserPhotosAndVideos";
import { User } from "~/common/Store/models/User";
import { ProductDetailGroupingSelect } from "~/ProductDetails/ProductDetailPageResult";
import LeaveAReview from ".";
import { MediaIdentifier, MediaReview } from "../../reviewModels";
export interface LeaveAReviewAndMediaThumbnailsWrapperProps {
  itemNumber: string;
  user: User;
  isVirtualGroupMaster?: boolean;
  productDetailGroupingSelect?: ProductDetailGroupingSelect[];
  handleVirtualGroupingSelectChange?: (itemNumber: string) => string;
  hasMediaReviews: boolean;
  handleSelectMediaElement: (newMedia: MediaIdentifier | undefined) => void;
  isEverliving?: boolean;
  isProductReviewPage?: boolean;
  image: string;
  description: string;
  productLink?: string;
  mediaReviewsOrdered: MediaReview[];
}
const LeaveAReviewAndMediaThumbnailsWrapper = (props: LeaveAReviewAndMediaThumbnailsWrapperProps) => {
  const {
    description,
    handleSelectMediaElement,
    handleVirtualGroupingSelectChange = undefined,
    hasMediaReviews,
    image,
    isEverliving,
    isProductReviewPage,
    isVirtualGroupMaster = false,
    itemNumber,
    mediaReviewsOrdered,
    productDetailGroupingSelect = [],
    productLink,
    user
  } = props;
  return <>
      {!isEverliving && <LeaveAReview user={user} itemNumber={itemNumber} displayExtended={false} productDetailGroupingSelect={productDetailGroupingSelect} handleVirtualGroupingSelectChange={handleVirtualGroupingSelectChange} isVirtualGroupMaster={isVirtualGroupMaster} isProductReviewPage={isProductReviewPage} image={image} description={description} productLink={productLink} hasMediaReview={hasMediaReviews} className={`block lt:hidden`} />}

      {hasMediaReviews && <UserPhotosAndVideos mediaReviews={mediaReviewsOrdered} handleSelectMediaElement={handleSelectMediaElement} isProductReviewPage={isProductReviewPage} />}

      {!isEverliving && <LeaveAReview user={user} itemNumber={itemNumber} displayExtended={false} productDetailGroupingSelect={productDetailGroupingSelect} handleVirtualGroupingSelectChange={handleVirtualGroupingSelectChange} isVirtualGroupMaster={isVirtualGroupMaster} isProductReviewPage={isProductReviewPage} image={image} description={description} productLink={productLink} hasMediaReview={hasMediaReviews} className={`hidden lt:block`} />}
    </>;
};
export default LeaveAReviewAndMediaThumbnailsWrapper;